import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';

const VueTelInputOptions = {
  mode: 'international',
};

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.use(VueTelInput, VueTelInputOptions);
});
